import { ActionTree, GetterTree, MutationTree } from 'vuex';
import { TakipEntity } from '@/entity/TakipEntity';
import { TakipDurumu } from '@/enum/TakipDurumu';
import { ProgramPaths } from '@/enum/ProgramPaths';
import axios from 'axios';
import createPersistedState from 'vuex-persistedstate';
import TakipDetayService from '@/services/takipDetayService';
import router from '@/router';
import { FaizTuruEntity } from '@/entity/FaizTuruEntity';
import { AlacakKalemiAlaniEntity } from '@/entity/AlacakKalemiAlaniEntity';
import Vue from 'vue';

interface FaizDataType {
  hesaplanabilir: boolean;
  data: TakipEntity | { message: string };
}

export interface TakipDetayState {
  takip: TakipEntity;
  faizData: FaizDataType;
  faizLoading: boolean;
  aktifTakipDurumu: TakipDurumu | null;
  hesapTarihi: Date | null;
  isListesiShouldReload: boolean;
  takipOncesiFaizTurleriMap: Record<number, FaizTuruEntity>;
  alacakKalemiAlanlariMap: Record<number, AlacakKalemiAlaniEntity>;
  nafakaDurduruldu: boolean;
}

const state: TakipDetayState = {
  takip: new TakipEntity(),
  faizData: { hesaplanabilir: false, data: { message: '' } },
  faizLoading: true,
  aktifTakipDurumu: null,
  hesapTarihi: null,
  isListesiShouldReload: false,
  takipOncesiFaizTurleriMap: {},
  alacakKalemiAlanlariMap: {},
  nafakaDurduruldu: false
};


const mutations: MutationTree<TakipDetayState> = {
  SET_TAKIP(state, takip: TakipEntity) {
    state.takip = takip;
  },
  SET_FAIZ_DATA(state, faizData: FaizDataType) {
    state.faizData = faizData;
  },
  SET_FAIZ_LOADING(state, loading: boolean) {
    state.faizLoading = loading;
  },
  SET_AKTIF_TAKIP_DURUMU(state, durumu: TakipDurumu) {
    state.aktifTakipDurumu = durumu;
  },
  SET_HESAP_TARIHI(state, tarih: Date) {
    state.hesapTarihi = tarih;
  },
  SET_NAFAKA_DURDURULDU(state, val: boolean) {
    state.nafakaDurduruldu = val;
  },

  /* ALACAKLILAR */
  SET_ALACAKLILAR(state, alacaklilar: any[]) {
    state.takip.alacaklilar = alacaklilar;
  },
  ADD_ALACAKLI(state, yeni: any) {
    state.takip.alacaklilar.push(yeni);
  },
  REMOVE_ALACAKLI(state, id: number) {
    state.takip.alacaklilar = state.takip.alacaklilar.filter(a => a.id !== id);
  },

  /* BORÇLULAR */
  SET_BORCLULAR(state, borclular: any[]) {
    // Her borçlunun vekiller, tebligatlar, borclu_bilgileri ve adresler field'larını initialize et
    if (borclular && Array.isArray(borclular)) {
      state.takip.borclular = borclular.map(borclu => ({
        ...borclu,
        vekiller: borclu.vekiller || [],
        tebligatlar: borclu.tebligatlar || [],
        borclu_bilgileri: borclu.borclu_bilgileri || null,
        adresler: borclu.adresler || [],
        varsayilan_adres: borclu.varsayilan_adres || null
      }));
    } else {
      state.takip.borclular = borclular || [];
    }
  },
  ADD_BORCLU(state, yeni: any) {
    state.takip.borclular.push(yeni);
  },
  REMOVE_BORCLU(state, id: number) {
    state.takip.borclular = state.takip.borclular.filter(b => b.id !== id);
  },
  SET_BORCLU_VEKILLER(state, payload: { borcluId: number, vekiller: any[] }) {
    if (state.takip.borclular) {
      const borclu = state.takip.borclular.find(b => b.id === payload.borcluId);
      if (borclu) {
        borclu.vekiller = payload.vekiller;
      }
    }
  },
  SET_BORCLU_TEBLIGATLAR(state, payload: { borcluId: number, tebligatlar: any[] }) {
    if (state.takip.borclular) {
      const borclu = state.takip.borclular.find(b => b.id === payload.borcluId);
      if (borclu) {
        borclu.tebligatlar = payload.tebligatlar;
      }
    }
  },
  SET_BORCLU_BILGILERI(state, payload: { borcluId: number, borclu_bilgileri: any }) {
    if (state.takip.borclular) {
      const borclu = state.takip.borclular.find(b => b.id === payload.borcluId);
      if (borclu) {
        borclu.borclu_bilgileri = payload.borclu_bilgileri;
      }
    }
  },
  SET_BORCLU_ADRESLER(state, payload: { borcluId: number, adresler: any[], varsayilan_adres: any }) {
    if (state.takip.borclular) {
      const borclu = state.takip.borclular.find(b => b.id === payload.borcluId);
      if (borclu) {
        borclu.adresler = payload.adresler;
        borclu.varsayilan_adres = payload.varsayilan_adres;
      }
    }
  },

  /* İŞ LİSTESİ */
  SET_IS_LISTESI(state, list: any[]) {
    state.takip.is_listesi = [...list];
  },
  ADD_IS_LISTESI(state, yeni: any) {
    state.takip.is_listesi = [...state.takip.is_listesi, yeni];
  },
  UPDATE_IS_LISTESI(state, guncellenen: any) {
    state.takip.is_listesi = state.takip.is_listesi.map(i =>
        i.id === guncellenen.id ? guncellenen : i
    );
  },
  REMOVE_IS_LISTESI(state, id: number) {
    state.takip.is_listesi = state.takip.is_listesi.filter(i => i.id !== id);
  },

  /* NOTLAR */
  SET_NOTLAR(state, notlar: any[]) {
    state.takip.notlar = notlar;
  },
  ADD_NOT(state, yeni: any) {
    state.takip.notlar.push(yeni);
  },
  REMOVE_NOT(state, id: number) {
    state.takip.notlar = state.takip.notlar.filter(n => n.id !== id);
  },

  /* ALACAKLAR */
  SET_ALACAKLAR(state, alacaklar: any[]) {
    // Yeni referans oluştur ki Vue reactivity tetiklensin
    state.takip = {
      ...state.takip,
      alacaklar: alacaklar || []
    };
  },
  ADD_ALACAK(state, yeni: any) {
    if (!state.takip.alacaklar) {
      state.takip = { ...state.takip, alacaklar: [yeni] };
    } else {
      state.takip = {
        ...state.takip,
        alacaklar: [...state.takip.alacaklar, yeni]
      };
    }
  },
  REMOVE_ALACAK(state, id: number) {
    if (state.takip.alacaklar) {
      state.takip = {
        ...state.takip,
        alacaklar: state.takip.alacaklar.filter(a => a.id !== id)
      };
    }
  },
  UPDATE_ALACAK(state, guncellenen: any) {
    if (state.takip.alacaklar) {
      const updatedAlacaklar = state.takip.alacaklar.map(a =>
        a.id === guncellenen.id ? guncellenen : a
      );
      state.takip = {
        ...state.takip,
        alacaklar: updatedAlacaklar
      };
    }
  },

  SET_IS_LISTESI_SHOULD_RELOAD(state, value: boolean) {
    state.isListesiShouldReload = value;
  },
  SET_FAIZ_TURLERI_MAP(state, value: Record<number, FaizTuruEntity>) {
    state.takipOncesiFaizTurleriMap = value;
  },
  SET_ALACAK_KALEMI_ALANLARI_MAP(state, value: Record<number, AlacakKalemiAlaniEntity>) {
    state.alacakKalemiAlanlariMap = value;
  }
};
const actions: ActionTree<TakipDetayState, any> = {
  async ensureFaizTurleri({ state, commit }) {
    if (state.takipOncesiFaizTurleriMap && Object.keys(state.takipOncesiFaizTurleriMap).length > 0) {
      return state.takipOncesiFaizTurleriMap;
    }
    try {
      const response = await Vue.prototype.$http.get('/api/v1/faiz-tur-list');
      const map: Record<number, FaizTuruEntity> = {};
      const list = Array.isArray(response.data) ? response.data : (response.data?.data || []);
      list.forEach((item: any) => {
        if (item && item.id != null) {
          map[item.id] = item;
        }
      });
      commit('SET_FAIZ_TURLERI_MAP', map);
      return map;
    } catch (error) {
      console.error('Faiz türleri yüklenirken hata oluştu:', error);
      return state.takipOncesiFaizTurleriMap;
    }
  },

  async loadTakip({ commit, state, dispatch }, takipId: string) {
    try {
      console.log('Takip verisi API\'dan alınıyor:', takipId);
      await dispatch('ensureFaizTurleri');
      const tumVeriler = await TakipDetayService.getTakipTumVeriler(takipId);


      if (tumVeriler && tumVeriler.takip) {
        const takipData = {
          ...tumVeriler.takip,
          alacaklilar: tumVeriler.alacaklilar || [],
          borclular: tumVeriler.borclular || [],
          alacaklar: tumVeriler.alacaklar || [],
          is_listesi: tumVeriler.isListesi || []
        };

        commit('SET_TAKIP', takipData);
        commit('SET_AKTIF_TAKIP_DURUMU', takipData.takip_durumu);
        commit('SET_ALACAKLILAR', takipData.alacaklilar);
        commit('SET_BORCLULAR', takipData.borclular);
        if (takipData.borclular && takipData.borclular.length > 0) {
          await dispatch('loadBorcluVekillerVeTebligatlar', takipData.borclular);
        }
        commit('SET_ALACAKLAR', takipData.alacaklar);
        commit('SET_IS_LISTESI', takipData.is_listesi);

        await dispatch('loadFaizData', takipId);
        return takipData;
      }

      return null;
    } catch (error) {
      console.error('Takip yüklenirken hata oluştu:', error);
      throw error;
    }
  },

  async loadFaizData({ commit, state }, takipId: string) {
    commit('SET_FAIZ_LOADING', true);

    try {
      console.log('Faiz verisi API\'dan alınıyor:', takipId);
      let response;
      const tarih = state.takip.takip_tarihi;
      if (
        state.takip.takip_durumu === TakipDurumu.acik &&
        tarih &&
        typeof tarih !== 'boolean' &&
        ((tarih instanceof Date && !isNaN(tarih.getTime())) || (!isNaN(Date.parse(tarih))))
      ) {
        // Eğer tarih Date ise veya parse edilebiliyorsa gönder
        const validDate = tarih instanceof Date ? tarih : new Date(tarih);
        commit('SET_HESAP_TARIHI', validDate);
        response = await TakipDetayService.getFaizData(takipId, validDate);
      } else {
        response = await TakipDetayService.getFaizData(takipId);
      }

      console.log('TakipDetayService.getFaizData\'dan gelen yanıt:', response);

      // API yanıtını doğru formata dönüştür
      let formattedData = {};
      if (response && typeof response === 'object') {
        if (response.hesaplanabilir !== undefined) {
          // Response zaten doğru formatta, olduğu gibi kullan
          formattedData = response;
        } else {
          // Response bir TakipEntity nesnesi, doğru formata çevir
          formattedData = {
            hesaplanabilir: true,
            data: response
          };
        }
      } else {
        // Geçersiz yanıt durumunda
        formattedData = {
          hesaplanabilir: false,
          data: { message: 'Faiz verisi alınamadı' }
        };
      }

      console.log('Store\'a kaydedilecek faiz verisi:', formattedData);
      commit('SET_FAIZ_DATA', formattedData);

      console.log('State\'teki faiz verisi (SET_FAIZ_DATA sonrası):', state.faizData);
      return formattedData;
    } catch (error) {
      console.error('Faiz verisi yüklenirken hata oluştu:', error);
      const errorData = {
        hesaplanabilir: false,
        data: { message: 'Faiz verisi yüklenirken hata oluştu' }
      };
      commit('SET_FAIZ_DATA', errorData);
      return errorData;
    } finally {
      commit('SET_FAIZ_LOADING', false);
    }
  },

  /* BORCLULAR */
  async loadBorclular({ commit, dispatch }, takipId: string) {
    const res = await TakipDetayService.getBorcluByTakipId(takipId);
    commit('SET_BORCLULAR', res);
    if (res && res.length > 0) {
      await dispatch('loadBorcluVekillerVeTebligatlar', res);
    }
  },
  async loadBorcluVekillerVeTebligatlar({ commit }, borclular: any[]) {
    // Her borçlu için paralel olarak vekiller, tebligatlar, borçlu bilgileri ve adresleri yükle
    const promises = borclular.map(async (borclu) => {
      if (!borclu.id) return;

      try {
        // Tüm verileri paralel olarak çek
        const [vekiller, tebligatlar, borclu_bilgileri, adresData] = await Promise.all([
          TakipDetayService.getVekillerByBorcluId(borclu.id),
          TakipDetayService.getTebligatlarByBorcluId(borclu.id),
          TakipDetayService.getBorcluBilgileriById(borclu.id),
          TakipDetayService.getAdreslerByBorcluId(borclu.id)
        ]);

        // Store'da ilgili borçlunun tüm verilerini güncelle
        commit('SET_BORCLU_VEKILLER', { borcluId: borclu.id, vekiller });
        commit('SET_BORCLU_TEBLIGATLAR', { borcluId: borclu.id, tebligatlar });
        commit('SET_BORCLU_BILGILERI', { borcluId: borclu.id, borclu_bilgileri });
        commit('SET_BORCLU_ADRESLER', {
          borcluId: borclu.id,
          adresler: adresData.adresler,
          varsayilan_adres: adresData.varsayilan_adres
        });
      } catch (error) {
        console.error(`Borçlu ${borclu.id} için veriler yüklenirken hata:`, error);
      }
    });

    // Tüm borçluların verileri yüklenene kadar bekle
    await Promise.all(promises);
  },
  async addBorclular({ commit }, { takipId, borclu }: { takipId: string; borclu: any }) {
    const res = await axios.post(`/api/v1/takip/${takipId}/borclular`, borclu);
    commit('ADD_BORCLU', res.data);
    return res.data;
  },
  async deleteBorclu({ commit, dispatch }, { takipId, id }) {
    await axios.delete(`/api/v1/takip/${takipId}/borclular/${id}`);
    commit('REMOVE_BORCLU', id);
    await dispatch('loadBorclular', takipId);
  },
  async updateBorclu({ dispatch }, { takipId, borclu }: { takipId: string; borclu: any }) {
    await axios.put(`/api/v1/takip/${takipId}/borclular/${borclu.id}`, borclu);
    return dispatch('loadBorclular', takipId);
  },

  /* ALACAKLI */
  async loadAlacaklilar({ commit }, takipId: string) {
    const res = await TakipDetayService.getAlacaklilarByTakipId(takipId);
    commit('SET_ALACAKLILAR', res);
  },
  async addAlacaklilar({ commit }, { takipId, alacakli }: { takipId: string; alacakli: any }) {
    const res = await axios.post(`/api/v1/takip/${takipId}/alacaklilar`, alacakli);
    commit('ADD_ALACAKLI', res.data);
    return res.data;
  },
  async deleteAlacaklilar({ commit, dispatch }, { takipId, id }) {
    await axios.delete(`/api/v1/takip/${takipId}/alacaklilar/${id}`);
    commit('REMOVE_ALACAKLI', id);
    await dispatch('loadAlacaklilar', takipId);
  },
  async updateAlacaklilar({ dispatch }, { takipId, alacakli }) {
    await axios.put(`/api/v1/takip/${takipId}/alacaklilar/${alacakli.id}`, alacakli);
    return dispatch('loadAlacaklilar', takipId);
  },

  /* İŞ LİSTESİ */
  async loadIsListesi({ commit }, takipId: string) {
    const res = await TakipDetayService.getIsListesiByTakipId(takipId);
    commit('SET_IS_LISTESI', res);
  },
  async addIsListesi({ commit, dispatch }, { takipId, isListesi }: { takipId: string; isListesi: any }) {
    const { data } = await axios.post(`/api/v1/takip/${takipId}/is-listesi`, isListesi);
    commit('ADD_IS_LISTESI', data);
    return dispatch('loadIsListesi', takipId);
  },
  async updateIsListesi({ commit, dispatch }, { takipId, isListesi }: { takipId: string; isListesi: any }) {
    const { data } = await axios.put(
        `/api/v1/takip/${takipId}/is-listesi/${isListesi.id}`,
        isListesi
    );
    commit('UPDATE_IS_LISTESI', data);
    return dispatch('loadIsListesi', takipId);
  },
  async deleteIsListesi({ commit, dispatch }, { takipId, id }: { takipId: string; id: number }) {
    await axios.delete(`/api/v1/takip/${takipId}/is-listesi/${id}`);
    commit('REMOVE_IS_LISTESI', id);
    return dispatch('loadIsListesi', takipId);
  },

  /*NOTLAR*/
  async loadNotlar({ commit }, takipId: string) {
    const res = await TakipDetayService.getNotlarByTakipId(takipId);
    commit('SET_NOTLAR', res);
  },
  async deleteNotlar({ commit, dispatch }, { takipId, id }: { takipId: string; id: number }) {
    await axios.delete(`/api/v1/takip/${takipId}/notlar/${id}`);
    commit('REMOVE_NOT', id);
    await dispatch('loadNotlar', takipId);
  },
  async updateNotlar({ dispatch }, { takipId, notlar }: { takipId: string; notlar: any }) {
    await axios.put(`/api/v1/takip/${takipId}/notlar/${notlar.id}`, notlar);
    return dispatch('loadNotlar', takipId);
  },
  async addNot({ commit, dispatch }, { takipId, not }: { takipId: string; not: any }) {
    const res = await axios.post(`/api/v1/takip/${takipId}/notlar`, not);
    commit('ADD_NOT', res.data);
    return res.data;
  },

  /* ALACAKLAR */
  async loadAlacaklar({ commit }, takipId: string) {
    const res = await Vue.prototype.$http.get(`/api/v1/takip/${takipId}/alacaklar`);
    // API yanıtı: { data: { alacaklar: [...] } } formatında geliyor
    // Axios interceptor data unwrapping yapıyor olabilir
    const alacaklar = res.data?.data?.alacaklar || res.data?.alacaklar || res.data || [];
    commit('SET_ALACAKLAR', alacaklar);
    return alacaklar;
  },
  async addAlacak({ commit, dispatch }, { takipId, alacak }: { takipId: string; alacak: any }) {
    const res = await Vue.prototype.$http.post(`/api/v1/takip/${takipId}/alacaklar`, alacak);
    commit('ADD_ALACAK', res.data);
    return res.data;
  },
  async deleteAlacaklar({ commit, dispatch }, { takipId, id }: { takipId: string; id: number }) {
    await Vue.prototype.$http.delete(`/api/v1/takip/${takipId}/alacaklar/${id}`);
    commit('REMOVE_ALACAK', id);
    await dispatch('loadAlacaklar', takipId);
  },
  async updateAlacak({ commit, dispatch }, { takipId, id }: { takipId: string; id: number }) {
    const res = await Vue.prototype.$http.get(`/api/v1/takip/${takipId}/alacaklar/${id}`);
    commit('UPDATE_ALACAK', res.data);
    return res.data;
  },

  /*FAİZ - KAPAK HESABI*/
  async loadFaiz({ commit }, takipId: string) {
    const res = await TakipDetayService.getFaizData(takipId);
    commit('SET_KAPAK_HESABI', res.data);
  },
  async updateFaiz ({ dispatch }, { takipId, faiz }: { takipId: string; faiz: any }) {
    await axios.put(`/api/v1/takip/${takipId}/faiz`, faiz);
    return dispatch('loadFaiz', takipId);
  },

  async takipAtla({ state }, sonrakiMi: boolean) {
    const filteredTakip = localStorage.getItem('filteredTakip');
    if (filteredTakip == null) return;

    const filtreliTakipler = JSON.parse(filteredTakip);

    if (sonrakiMi && filtreliTakipler.index != filtreliTakipler.data.length - 1) {
      filtreliTakipler.index++;
      localStorage.setItem('filteredTakip', JSON.stringify(filtreliTakipler));
      const takipId = filtreliTakipler.data[filtreliTakipler.index];

      const response = await axios.get(`/api/v1/takip/${takipId}/takip-durumu`);
      if (response.data != TakipDurumu.acilmamis) {
        return { path: `${ProgramPaths.icrapro}/takip/${takipId}` };
      } else {
        return { path: `${ProgramPaths.icrapro}/takip-ekle/${takipId}` };
      }
    } else if (!sonrakiMi && filtreliTakipler.index != 0) {
      filtreliTakipler.index--;
      localStorage.setItem('filteredTakip', JSON.stringify(filtreliTakipler));
      const takipId = filtreliTakipler.data[filtreliTakipler.index];

      const response = await axios.get(`/api/v1/takip/${takipId}/takip-durumu`);
      if (response.data != TakipDurumu.acilmamis) {
        return { path: `${ProgramPaths.icrapro}/takip/${takipId}` };
      } else {
        return { path: `${ProgramPaths.icrapro}/takip-ekle/${takipId}` };
      }
    }

    return null;
  },

  async takipAtlaWrapper({ dispatch }, isForward: boolean) {
    try {
      const result = await dispatch('takipAtla', isForward);
      if (result && result.path) {
        router.push(result.path);
      }
    } catch (error) {
      console.error('Takip atlama işlemi sırasında bir hata oluştu:', error);
      throw error;
    }
  },

  setActiveProcess({ commit }, process: { id: string, key: string }) {
    return process;
  },

  triggerIsListesiReload({ commit }) {
    commit('SET_IS_LISTESI_SHOULD_RELOAD', true);
  },
  resetIsListesiReload({ commit }) {
    commit('SET_IS_LISTESI_SHOULD_RELOAD', false);
  },

  async durdurNafaka({ commit, state }) {
    const takipId = state.takip?.id;
    if (!takipId) throw new Error('Takip ID bulunamadı');
    await TakipDetayService.durdurNafaka(String(takipId));
    commit('SET_NAFAKA_DURDURULDU', true);
  }
};

const getters: GetterTree<TakipDetayState, any> = {
  takip: state => state.takip,
  faizData: state => state.faizData,
  faizLoading: state => state.faizLoading,
  aktifTakipDurumu: state => state.aktifTakipDurumu,
  alacaklilar: state => state.takip.alacaklilar,
  borclular: state => state.takip.borclular,
  isListesi: state => state.takip.is_listesi,
  notlar: state => state.takip.notlar,
  isListesiShouldReload: state => state.isListesiShouldReload,
  takipOncesiFaizTurleriMap: state => state.takipOncesiFaizTurleriMap,
  alacakKalemiAlanlariMap: state => state.alacakKalemiAlanlariMap,
  nafakaDurduruldu: state => state.nafakaDurduruldu
};

const plugins = [
  createPersistedState({
    paths: [
      'takipDetay.takip',
      'takipDetay.faizData',
      'takipDetay.faizLoading',
      'takipDetay.aktifTakipDurumu',
      'takipDetay.hesapTarihi',
      'takipDetay.isListesiShouldReload'
    ]
  })
];

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
  plugins
};
